var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForest = function SvgForest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "forest_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      masktype: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#forest_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 21v-4H1.885l3.965-6H3.923L9 3.73l3 4.3 3-4.3L20.077 11H18.15l3.966 6H16v4h-2v-4h-4v4zm7.456-5h4.817l-3.97-6h1.847L15 5.5 12.63 8.89 14.077 11H12.15zM3.727 16h10.546l-3.97-6h1.847L9 5.5 5.85 10h1.848zm0 0h3.971H5.85h6.3-1.848 3.971zm11.729 0H12.15h1.927-1.448 5.521-1.848 3.971z"
  }))));
};
export default SvgForest;